import React from 'react';
import { Coins } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function CreditsDisplay({ credits = 0, onClick }) {
	const navigate = useNavigate();
	const low = credits < 2;
	return (
		<button
			onClick={onClick || (() => navigate('/credits'))}
			className={`flex items-center gap-1 px-2 py-1 rounded-md text-sm ${
				low ? 'text-red-600 bg-red-50' : 'text-primary-700 bg-primary-50'
			}`}
			title={`${credits} credits`}
		>
			<Coins className="w-4 h-4" />
			<span>{credits}</span>
		</button>
	);
}


